import { Box, Typography } from "@mui/material";
import TextButton from "../../../../../components/buttons/TextButton";
import CustomTooltip from "../../../../../components/CustomTooltip";
import SvgToIcon from "../../../../../icons/SvgToIcon";
import { icons } from "../../../../stack/environment/icons/iconExport";

const MetricCard = ({
  label,
  value,
  unit,
  showViewGap = false,
  controlId,
  onViewGap,
  colors,
  trend,
  sx = {},
}) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: "100%",
        ...sx,
      }}
    >
      <Typography
        variant="body2"
        sx={{
          color: colors.text_secondary,
        }}
      >
        {label}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            flexDirection: "row",
            gap: 0.5,
          }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              color: colors.primary_400,
            }}
          >
            {Math.round(value)} {unit}
          </Typography>
          {trend && trend.diff !== 0 && (
            <CustomTooltip
              title={
                trend.isPositive
                  ? "Improvement compared to previous period"
                  : "Decline compared to previous period"
              }
              placement="top"
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <SvgToIcon
                  IconLogo={
                    trend.isPositive ? icons.ArrowDownIcon : icons.ArrowUpIcon
                  }
                  style={{
                    width: "16px",
                    height: "16px",
                    color: trend.isPositive
                      ? colors.success_400
                      : colors.error_400,
                  }}
                />
                <Typography
                  variant="caption"
                  sx={{
                    color: trend.isPositive
                      ? colors.success_400
                      : colors.error_400,
                  }}
                >
                  {trend.isPositive ? "" : "+"}
                  {Math.round(trend.diff)}
                </Typography>
              </Box>
            </CustomTooltip>
          )}
        </Box>
        {showViewGap && controlId && (
          <CustomTooltip title="Open in new tab" placement="top">
            <Box>
              <TextButton
                onClick={() => onViewGap(controlId)}
                sx={{
                  width: "fit-content",
                  color: colors.action_active,
                }}
                endIcon={icons.NewTabIcon}
              >
                <Typography variant="overline"> View gap</Typography>
              </TextButton>
            </Box>
          </CustomTooltip>
        )}
      </Box>
    </Box>
  );
};

export default MetricCard;
